// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2jpg0","imageUploader":"EGiftCard_imageUploader__RujJJ"};